import { RootReducerType } from "../CombineReducer";

export const useGetSiteList = (state: RootReducerType) => state.sites.siteList;
export const useSiteLoading = (state: RootReducerType) => state.sites.isLoading;
export const useGetSiteDetail = (state: RootReducerType) => state.sites.selectedSiteDetail;
export const useGetSitePropertyList = (state: RootReducerType) => state.sites.manageProperty;
export const useGetSitePropertyDetail = (state: RootReducerType) => state.sites.selectedPropertyDetail;
export const useGetPropertyServices = (state: RootReducerType) => state.sites.selectedPropertyDetail?.services;
export const useGetPropertyCustomer = (state: RootReducerType) => state.sites.propertyCustomers;
